const cookie = require('cookie_js');

const opt = {
	cookie: ".js-cookie-media"
};
	
	// Создание Cookie для работы вывода определённых новостей по пути /lang/media/news
$(opt.cookie).on('click', function (e) {
	const   $obj = $(this),
			typeNews = $obj.data("type-news"),
			currentDate = new Date();

	currentDate.setSeconds(currentDate.getSeconds() + 10);

	cookie.set("FilterNewsType", typeNews, {
		expires: currentDate.toGMTString()
	});
});



// WEBPACK FOOTER //
// ./frontend/components/media/media.js